// ─── Node dimensions ───────────────────────────────────────────────────────────

export const AREA_NODE_WIDTH = 320;
export const AREA_NODE_HEIGHT = 96;

export const TOPIC_NODE_WIDTH = 220;
export const TOPIC_NODE_HEIGHT = 52;

// ─── Dagre layout spacing ──────────────────────────────────────────────────────

export const DAGRE_CONFIG = {
  rankdir: "TB" as const,
  nodesep: 44,
  ranksep: 64,
  edgesep: 16,
};

// ─── Animation timing ──────────────────────────────────────────────────────────

export const REVEAL_AREA_STAGGER_MS = 140;
export const REVEAL_TOPIC_STAGGER_MS = 80;
export const REVEAL_EDGE_OFFSET_MS = 100;
export const EXPAND_ANIMATION_MS = 300;
export const COLLAPSE_ANIMATION_MS = 200;

// ─── Spring config ─────────────────────────────────────────────────────────────

export const NODE_SPRING = {
  type: "spring" as const,
  stiffness: 320,
  damping: 28,
};

// ─── Status colors ─────────────────────────────────────────────────────────────

export const STATUS_COLORS = {
  known: {
    dot: "#22c55e",
    bg: "#f0fdf4",
    border: "#bbf7d0",
    text: "#15803d",
    edge: "#22c55e",
  },
  next: {
    dot: "#3b82f6",
    bg: "#eff6ff",
    border: "#93c5fd",
    text: "#1d4ed8",
    edge: "#3b82f6",
  },
  to_learn: {
    dot: "#d1d5db",
    bg: "#f9fafb",
    border: "#e5e7eb",
    text: "#6b7280",
    edge: "#d1d5db",
  },
} as const;

export const CATEGORY_COLORS: Record<string, { bg: string; border: string; text: string; accent: string }> = {
  architecture:       { bg: "#eff6ff", border: "#bfdbfe", text: "#1d4ed8", accent: "#3b82f6" },
  storage_engines:    { bg: "#f0fdf4", border: "#bbf7d0", text: "#15803d", accent: "#22c55e" },
  data_modeling:      { bg: "#fefce8", border: "#fde68a", text: "#a16207", accent: "#eab308" },
  querying:           { bg: "#fdf4ff", border: "#e9d5ff", text: "#7e22ce", accent: "#a855f7" },
  advanced_querying:  { bg: "#fff7ed", border: "#fed7aa", text: "#c2410c", accent: "#f97316" },
  operations:         { bg: "#f0f9ff", border: "#a5f3fc", text: "#0e7490", accent: "#06b6d4" },
  performance:        { bg: "#fff1f2", border: "#fecdd3", text: "#be123c", accent: "#f43f5e" },
};

const DEFAULT_CATEGORY_COLOR = { bg: "#f9fafb", border: "#e5e7eb", text: "#374151", accent: "#6b7280" };

export function getCategoryColor(category: string) {
  return CATEGORY_COLORS[category] ?? DEFAULT_CATEGORY_COLOR;
}
